import EtsyFeeCalculator from '@/tools/etsyFeeCalculator.vue';
import { mountVueTool } from './shared/mountVueTool';

mountVueTool(EtsyFeeCalculator, 'etsyFeeCalculator');
